import React, { useState } from "react";
import AdvertCard from "../../Listings/Components/AdvertCard";
import AdvertMenu from "../AdvertsMenu/AdvertsMenu";
import { Row, Col, Typography, Pagination, Empty, Spin, Card } from "antd";
import usePersonnelAdvertService from "../../../services/usePersonnelAdvertService";
import { theme } from "../../../utils/theme";

const { Title, Text } = Typography;

export const FavoritesPage = () => {
  const { useGetFavoriteAdverts } = usePersonnelAdvertService();
  const [pagination, setPagination] = useState({ page: 0, size: 5 });

  const { data: favoriteAdverts, isLoading } =
    useGetFavoriteAdverts(pagination);

  const adverts = favoriteAdverts?.data?.data || [];
  const totalItems = favoriteAdverts?.data?.total || 0;

  const getItemRangeText = () => {
    const start = pagination.page * pagination.size + 1;
    const end = Math.min((pagination.page + 1) * pagination.size, totalItems);
    return `${totalItems} ilan arasından, ${start}-${end} arasındakiler gösteriliyor`;
  };

  const handlePageChange = (page, pageSize) => {
    setPagination({ page: page - 1, size: pageSize });
  };

  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 24px",
  };

  const loadingContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "200px",
  };

  const emptyStateStyle = {
    background: "#f5f5f5",
    borderRadius: "8px",
    padding: "32px",
    textAlign: "center",
  };

  const paginationContainerStyle = {
    textAlign: "center",
    marginTop: "24px",
    marginBottom: "48px",
  };

  return (
    <>
      <div style={{ background: theme.lightPrimaryColor, padding: "16px" }}>
        <div style={containerStyle}>
          <Title
            level={1}
            style={{
              fontFamily: "Abel, sans-serif",
              fontWeight: 600,
              color: "white",
              margin: "0",
            }}>
            Favori İlanlarım
          </Title>
        </div>
      </div>

      <div style={{ ...containerStyle, padding: "24px 24px 48px 24px" }}>
        <Row gutter={24}>
          <Col xs={24} sm={24} md={6} lg={6}>
            <AdvertMenu />
          </Col>

          <Col xs={24} sm={24} md={18} lg={18}>
            {totalItems > 0 && !isLoading && (
              <Text
                type="secondary"
                style={{
                  fontSize: "14px",
                  display: "block",
                  marginBottom: "16px",
                }}>
                {getItemRangeText()}
              </Text>
            )}
            {isLoading && pagination.page === 0 ? (
              <div style={loadingContainerStyle}>
                <Spin size="large" />
              </div>
            ) : adverts.length === 0 ? (
              <Card style={emptyStateStyle}>
                <Empty
                  description="Henüz favori ilanınız yok."
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </Card>
            ) : (
              <>
                <Row gutter={[0, 16]}>
                  {adverts.map((advert, index) => (
                    <Col key={advert.id || index} span={24}>
                      <div style={{ maxWidth: "100%", margin: "0 auto" }}>
                        <AdvertCard advert={advert} />
                      </div>
                    </Col>
                  ))}
                </Row>
                <div style={paginationContainerStyle}>
                  <Pagination
                    current={pagination.page + 1}
                    total={totalItems}
                    pageSize={pagination.size}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              </>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};
